import {Utils, $, Jqext} from '../../app.base'

import {Vue, calcDomWidth, calcDomHeight, zIndexManager} from '../../app.vues'

let Toast = Jqext.Toast;
//
let exports = {};
// ====================================================================================

var __route_layer_container_selector = 'body > .page-wrap > .main-wrap > .content-area';
var __route_layer_count = 0;

//设置弹出层父容器组件
export function setRouteLayerContainerSelector(containerSelector) {
    if (containerSelector) {
        __route_layer_container_selector = containerSelector;
    }
}

//创建弹出层占位符（返回新的id）
function createRouteLayerHolder(containerSelector) {
    var jqContainer = $(containerSelector || __route_layer_container_selector);
    if (jqContainer.size() == 1) {
        var domEl = jqContainer.get(0);
        var theId = 'route-layer' + (++__route_layer_count);
        var theDom = document.createElement('div');
        theDom.id = theId;
        domEl.appendChild(theDom);
        return theId;
    } else {
        console.error('未找到容器（' + containerSelector + '）或找到多个');
        return null;
    }
}

// 获取弹出层容器大小（{width, height} or null）
export function getRouteLayerContainerSize(containerSelector) {
    var jqContainer = $(containerSelector || __route_layer_container_selector);
    if (jqContainer.size() == 1) {
        return {
            width: calcDomWidth(jqContainer, true),
            height: calcDomHeight(jqContainer, true)
        };
    } else {
        console.warn('未找到容器（' + containerSelector + '）或找到多个');
        return null;
    }
}

//路由默认最大弹层数
var __route_default_max_layers = 4;

export function setDefaultMaxLayers(defaultMaxLayers) {
    defaultMaxLayers = defaultMaxLayers || 0;
    if (typeof defaultMaxLayers == 'number' && defaultMaxLayers > 0) {
        __route_default_max_layers = defaultMaxLayers;
        console.info('默认最大弹层数设置为：' + __route_default_max_layers);
    }
}

// 弹出层管理器（兼容多页签route模式）
// layer 接口： close(), resize({ width, height })
// 扩展：多页签的root，非活动页签对应的 hide(), show()
export var RouteLayerMgr = {
    //调试开关
    debugMode: false,
    setDebugMode: function (debugMode) {
        this.debugMode = debugMode;
    },
    //路由对应的最大弹层数（默认为：__route_default_max_layers）
    routeMaxLayers: {},
    setMaxLayers: function (routePath, maxLayers) {
        routePath = routePath || this.routePath || '';
        if (routePath && typeof maxLayers == 'number' && maxLayers > 0) {
            this.routeMaxLayers[routePath] = maxLayers;
            if (this.debugMode) {
                console.log('最大弹层数：' + routePath + ' => ' + maxLayers);
            }
        }
    },
    getMaxLayers: function (routePath/*可选*/) {
        routePath = routePath || this.routePath || '';
        return this.routeMaxLayers[routePath] || __route_default_max_layers;
    },
    //当前 route
    routePath: null,
    //所有 route 弹层（ routePath => [layerComp,...]）
    routeLayers: {},
    //清除路由对应的弹层
    clearLayers: function (routePath /*可选*/) {
        routePath = routePath || this.routePath;
        if (routePath != null) {
            var layerComps = this.routeLayers[routePath] || [];
            var layerComp = null;
            for (var i = layerComps.length - 1; i >= 0; i--) {
                layerComp = layerComps.pop();
                try {
                    layerComp.close(true); //关闭弹层
                } catch (ex) {
                    console.error(ex);
                }
            }
        }
    },
    //获取当前路由
    getRoutePath: function () {
        return this.routePath;
    },
    //设置/变更当前路由（clearPrevLayers ：是否清除上一个路由的弹层）
    setRoutePath: function (routePath, clearPrevLayers /*可选*/) {
        routePath = routePath || '';
        clearPrevLayers = clearPrevLayers === true;
        //检查路由是否与当前的重复
        if (routePath == this.routePath) {
            if (this.debugMode) {
                console.warn('路由重复：' + this.routePath);
            }
            return;
        }
        // 清除上一个路由的弹层
        if (clearPrevLayers && this.routePath != null) {
            this.clearLayers(this.routePath);
        }
        // 设置当前路由
        this.routePath = routePath;
        if (this.debugMode) {
            console.log('当前路由：' + this.routePath);
        }
    },
    //判断路由对应的弹层是否可继续压入
    isPushable: function (routePath/*可选*/, layerComps /*可选*/) {
        routePath = routePath || this.routePath || '';
        if (!routePath) {
            return false;
        }
        //检查弹层数是否<最大限制
        layerComps = layerComps || this.routeLayers[routePath] || [];
        var maxLayers = this.getMaxLayers(routePath);
        return layerComps.length < maxLayers;
    },
    //获取路由弹层数
    getLayerCount: function (routePath) {
        routePath = routePath || this.routePath;
        if (routePath == null) {
            return 0;
        }
        var layerComps = this.routeLayers[routePath] || [];
        return layerComps.length;
    },
    //压入路由弹层
    pushLayer: function (layerComp, routePath /*可选*/) {
        routePath = routePath || this.routePath;
        if (routePath == null) {
            console.error('弹层对应的路由无效：' + routePath);
            return false;
        }
        var layerComps = this.routeLayers[routePath] || null;
        if (layerComps == null) {// 未初始化（则初始化）
            layerComps = this.routeLayers[routePath] = [];
        }
        if (!this.isPushable(routePath, layerComps)) {
            console.error('弹层已达到限制数：' + routePath + ' => ' + this.getMaxLayers(routePath));
            return false;
        }
        //
        try {
            layerComps.push(layerComp); //压入弹层
            return true;
        } catch (ex) {
            console.error(ex);
            return false;
        }
    },
    //弹出路由弹层
    popLayer: function (routePath /*可选*/, callClose /*是否调用close*/) {
        callClose = callClose === true;
        routePath = routePath || this.routePath;
        if (routePath == null) {
            console.error('弹层对应的路由无效：' + routePath);
            return false;
        }
        //
        var layerComps = this.routeLayers[routePath] || [];
        if (layerComps.length > 0) {
            var layerComp = layerComps.pop();
            try {
                if (callClose) {
                    layerComp.close(true); //关闭弹层
                }
                return true;
            } catch (ex) {
                console.error(ex);
            }
        }
        return false;
    },
    //重新调整弹层大小
    resizeLayers: function (size /* {width, height} */) {
        var routeLayers = this.routeLayers;
        for (var routePath in routeLayers) {
            var layerComps = routeLayers[routePath] || [];
            var layerComp = null;
            for (var i = layerComps.length - 1; i >= 0; i--) {
                layerComp = layerComps[i];
                try {
                    layerComp.resize(size); //重画弹层
                } catch (ex) {
                    console.error(ex);
                }
            }
        }
    },
    //销毁清理（释放html组件，防止内存泄漏）
    destroy: function () {
        //清除所有弹层（遍历 所有 route）
        var routeLayers = this.routeLayers;
        for (var routePath in routeLayers) {
            this.clearLayers(routePath);
            delete routeLayers[routePath];
        }
        //清除弹层限制（简单对象，置空即可）
        var routeMaxLayers = this.routeMaxLayers;
        for (var routePath in routeMaxLayers) {
            delete routeMaxLayers[routePath];
        }
    }
};
// ====================================================================================
//组件核心定义
var LayerVueDef = {
    name: 'swb-route-layer',
    desc: '路由弹出层',

    template: '<div name="route-layer-wrapper" tabindex="0" style="display: block; position: absolute; left: 0; top:0; right : 0; bottom : 0; cursor: default; overflow: hidden;" :style="{\'z-index\' : layerZIndex}">\
            <div name="route-layer-shade" tabindex="-1" style="display: block; position: absolute; left: 0; top:0; right : 0; bottom : 0;  cursor: default;  overflow: hidden; background-color: rgba(100,100,100,0.3);"></div>\
            <div name="route-layer-panel" :style="{left : panelLeft + \'px\', width : panelWidth}" style="display: block; position: relative; height: 100%; background-color: #FFFFFF;overflow: hidden; padding:0 10px 10px 10px;">\
                <div role="header" :style="{height : headerHeight + \'px\', \'line-height\' : (headerHeight -2) + \'px\'}" style="font-size: 14px; font-weight: bold; overflow: hidden; border-bottom: 1px solid #DDDDDD;">\
                    <slot name="title">{{title}}</slot>\
                    <span style="float: right; margin-right: 10px; display: inline-block; cursor: pointer; text-align: center; " @click="triggerClose()">\
                        <el-link style="color: #0C64EB; font-weight: bold;" v-if="closeAsBack"><i class="el-icon-back" style="color: #0C64EB;font-weight: bold;"></i>&nbsp;后退</el-link>\
                        <span v-else title="关闭"><i class="el-icon-close"></i></span>\
                    </span>\
                </div>\
                <div role="content" style="overflow: auto;" :style="{height : cntntHeight + \'px\'}">\
                    <slot name="content"></slot>\
                </div>\
                <div role="footer" v-if="showFooter" :style="{height : footerHeight + \'px\', \'line-height\' : (footerHeight -2) + \'px\'}" style="overflow: hidden; border-top: 1px solid #DDDDDD;">\
                    <slot name="footer"></slot>\
                </div>\
            </div>\
        </div>',
    props: {
        // 使用关闭模式（默认为回退模式）
        closeAsBack: {
            type: Boolean,
            default: false
        },
        showFooter: {
            type: Boolean,
            default: false
        },
        title: {
            type: String
        },
        // 负值代表空白宽度
        width: {
            default: '100%'
        },
        styleX: {
            default: null
        }
    },
    data: function () {
        return {
            //容器
            layerZIndex: zIndexManager.nextZIndex(true),
            //面板
            panelLeft: 0,
            panelWidth: '100%',
            //标头
            headerHeight: 50,
            //底栏
            footerHeight: 60,
            //内容
            cntntHeight: 400
        }
    },
    mounted() {
        //设置样式
        var styleX = this.styleX || null;
        if (styleX != null && Utils.isPlainObject(styleX)) {
            var thisEl = $(this.$el).find('>[name="route-layer-panel"]');
            for (var name in styleX) {
                thisEl.css(name, styleX[name]);
            }
        }
    },
    methods: {
        resize(width, height) {
            //console.log(width, height);
            var defWidth = this.width || '100%';
            var minWidth = 200; //内容区最小宽度
            if (typeof defWidth == 'string' && defWidth.endsWith('%')) {
                //百分比
                var percent = Utils.ParseInt(defWidth);
                if (percent >= 100) {
                    this.panelWidth = '100%';
                    this.panelLeft = 0;
                } else {
                    var panelWidth = Math.floor(width * percent / 100);
                    this.panelLeft = width - panelWidth;
                    this.panelWidth = panelWidth + 'px';
                }
            } else {
                defWidth = Utils.ParseInt(defWidth);
                //指定宽度
                if (defWidth < 0) {//负值指定空白宽度
                    var panelLeft = Math.abs(defWidth);
                    if (width - panelLeft >= minWidth) {//至少要保证内容宽度100
                        this.panelLeft = panelLeft;
                        var panelWidth = width - panelLeft;
                        this.panelWidth = panelWidth + 'px';
                    } else {
                        this.panelWidth = '100%';
                        this.panelLeft = 0;
                    }
                } else {//正值指定内容宽度
                    if (defWidth >= minWidth && defWidth < width) {
                        var panelWidth = defWidth;
                        this.panelWidth = panelWidth + 'px';
                        var panelLeft = width - panelWidth;
                        this.panelLeft = panelLeft;
                    }
                }
            }
            //
            this.cntntHeight = height - this.headerHeight - (this.showFooter ? this.footerHeight : 0);
        },
        triggerClose() {
            this.$emit('close');
        }
    }
};

/**
 * 显示右侧弹层组件
 * @param config 配置信息{title, data, template, onClose(layer), footerBtns [{name, text, className, handler(layer)}], width, closeAsBack, routePath, style}
 */
export function showRouteLayer(config) {
    config = config || {};
    //确定当前路由
    var theRoutePath = config['routePath'] || RouteLayerMgr.getRoutePath();
    if (!RouteLayerMgr.isPushable(theRoutePath)) {
        Toast.show('弹层已达最大限制', 5000, 'warning');
        return;
    }
    //
    var data = config.data || null;
    var query = data == null ? config.query || {} : null;
    if (data == null) {
        data = {
            query: query
        };
    }
    var template = config.template || '';
    if (typeof template !== 'string') {
        if (template != null && template.name) {
            var compName = template.name;
            template = '<{0} :query="query" style="height:100%;"></{0}>'.format(compName);
        }
    }
    //
    var newId = createRouteLayerHolder();
    // config
    var layerTitle = config['title'] || '未命名弹层：' + newId;
    var closeCbck = config['onClose'] || null; //关闭回调（返回false，则需要自行关闭）
    var layerStyle = config['style'] || {
        'padding-left': '20px',
        'padding-bottom': '0px'
    };
    // 关闭显示为回退（!false）
    var closeAsBack = config['closeAsBack'] !== false;
    var layerWidth = config['width'] || '100%';
    var indented = config['indented'] || false;
    if (indented) {
        if (Utils.isNumStr(layerWidth) && (layerWidth = parseFloat(layerWidth)) < 0) {
            //根据堆栈序号逐个增加
            var layerSeqNo = RouteLayerMgr.getLayerCount(theRoutePath) + 1;
            layerWidth = layerWidth * layerSeqNo;
        } else {
            indented = false;
            console.warn('逐级缩进仅当 width < 0 时有效');
        }
    }
    var footerBtns = config['footerBtns'] || [];
    var showFooter = footerBtns.length > 0;
    var footerBtnTpl = '<button style="margin-left: {3}px" class="swb-btn swb-btn-small {2}" name="{0}" @click="handleFooterBtn(\'{0}\')">{1}</button>';
    var footerBtnHtml = '<span style="float: right;margin-top:-2px">';
    for (var i = 0, c = footerBtns.length; i < c; i++) {
        var footerBtn = footerBtns[i];
        //处理常见按钮行为
        if (footerBtn.name == 'cancel' && footerBtn.handler == null) {
            footerBtn.handler = function () {
                this.close();
            }
        }
        footerBtnHtml += footerBtnTpl.format(footerBtn.name, footerBtn.text, footerBtn.className || (i == 0 ? '' : 'swb-btn-outlined'), i == 0 ? 0 : 40);
    }
    footerBtnHtml += '</span>';
    var footerBtnHandlerMap = {};
    footerBtns.forEach(function (btn) {
        footerBtnHandlerMap[btn.name] = btn.handler;
    });

    // 组件是否已销毁标记
    var layerClosed = false;
    //
    var layerComp = new Vue({
        components: {
            'swb-route-layer': LayerVueDef
        },
        data: Utils.merge({
            x_layerTitle: layerTitle,
            x_layerStyle: layerStyle,
            x_closeAsBack: closeAsBack,
            x_layerWidth: layerWidth,
            x_showFooter: showFooter,
            x_footerBtns: footerBtns
        }, data),
        //
        el: '#' + newId,
        template: '<swb-route-layer ref="the-route-layer" :title="x_layerTitle" :width="x_layerWidth" :styleX="x_layerStyle" :closeAsBack="x_closeAsBack" :showFooter="x_showFooter" @close="handleClose">' +
            '<template slot="content">' + template + '</template>' +
            '<div slot="footer">' + footerBtnHtml + '</div>' +
            '</swb-route-layer>',
        mounted() {
            this.resize();
        },
        methods: {
            close: function (poppedAlready) {
                if (!layerClosed) {
                    layerClosed = true;
                    //
                    poppedAlready = poppedAlready === true;
                    if (!poppedAlready) {
                        RouteLayerMgr.popLayer(theRoutePath, false);
                    }
                    //
                    this.$destroy();
                    this.$el.parentNode.removeChild(this.$el);
                }
            },
            handleClose: function () {
                if (typeof closeCbck == 'function') {
                    try {
                        if (closeCbck.call(this, this) === false) {
                            return;
                        }
                    } catch (ex) {
                        console.error(ex);
                    }
                }
                //
                RouteLayerMgr.popLayer(theRoutePath, true);
            },
            handleFooterBtn: function (btnName) {
                var handler = footerBtnHandlerMap[btnName];
                if (typeof handler == 'function') {
                    try {
                        handler.call(this, this);
                    } catch (ex) {
                        console.error(ex);
                    }
                }
            },
            resize: function (size) {
                var size = size || getRouteLayerContainerSize();
                if (size != null) {
                    let theCtrl = this.$refs['the-route-layer'];
                    theCtrl.resize(size.width, size.height);
                }
            }
        }
    });
    //
    RouteLayerMgr.pushLayer(layerComp, theRoutePath);
    //
    return layerComp;
}


// ====================================================================================
exports.RouteLayerMgr = RouteLayerMgr;
exports.getRouteLayerContainerSize = getRouteLayerContainerSize;

// ===================
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/compo/ctrl/RouteLayer.js
// module id = 60
// module chunks = 0